import React from 'react'
import { Feed } from './Feed'
import { Header } from './header'
import { Footer } from './Footer'

export const Homepage = () => {
  return (
    <div className=''>
      <Header/>
      <Feed/>
      <Footer/>
    </div>
  )
}


